export function assertNotNullOrReturnDefault<Value>(
  value: Value | null,
  defaultValue: Exclude<Value, null>,
): Exclude<Value, null> {
  if (value === null) {
    if (process.env.NODE_ENV === 'production') {
      return defaultValue;
    } else {
      throw new Error('value is null');
    }
  } else {
    return value as Exclude<Value, null>;
  }
}
